<template lang="pug">
  //- TOPに表示する形式
  span.info-box-icon(v-if="showMode === 'top'" :class="getColor")
    i.fa(:class="getIcon")
  //- 一覧に表示する形式
  i.fa.fa-fw(v-else :class="[getIcon, getColor]")
</template>

<script>
export default {
  name: 'InfoIcon',
  props: {
    // 機能番号
    functionCode: {
      type: [String, Number],
      required: false,
      default: ''
    },
    // お知らせ種別
    infoType: {
      type: [String],
      required: true
    },
    // 表示形式(list or top)
    showMode: {
      type: [String],
      required: false,
      default: 'list'
    }
  },
  data: function () {
    return {
      icons: {
        default: 'fa-circle', // default
        I: 'fa-flag', // お知らせ
        T: 'fa-flag', // TODO
        E: 'fa-exclamation-triangle' // エラー
      },
      colors: {
        default: 'black',
        I: 'green', // お知らせ:緑
        T: 'yellow', // TODO:黄
        E: 'red' // エラー:赤
      }
    }
  },
  computed: {
    getIcon: function () {
      let icon
      switch (this.infoType) {
        case 'I':
          icon = this.icons['I']
          break
        case 'T':
          icon = this.icons['T']
          break
        case 'E':
          icon = this.icons['E']
          break
        default:
          icon = this.icons['default']
      }

      return icon
    },
    getColor: function () {
      let color
      // classの色名の先頭に付く文字列
      const prefix = this.showMode === 'top' ? 'bg-' : 'text-'
      switch (this.infoType) {
        case 'I':
          color = prefix + this.colors['I']
          break
        case 'T':
          color = prefix + this.colors['T']
          break
        case 'E':
          color = prefix + this.colors['E']
          break
        default:
          color = prefix + this.colors['default']
      }

      return color
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/molecules/InfoIcon.vue